import { Text, View, Dimensions } from "react-native";
import React from "react";
import { StyleSheet } from "@/utils/appStyleSheet";
import Images from "@/assets/images";
import { Image } from "expo-image";
import { Colors } from "@/constants/Colors";
import { FontFamilies } from "@/constants/Typography";
import { ActionButton } from "@/components/ActionButton";
import Svg, { Path } from "react-native-svg";
import { BlurView } from "expo-blur";
import useWindow from "@/hooks/useWindow";

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get("window");

const RepeatIcon = () => (
  <Svg width="37" height="37" viewBox="0 0 37 37" fill="none">
    <Path
      d="M8.33333 5H33.3333C33.7754 5 34.1993 5.1756 34.5118 5.48816C34.8244 5.80072 35 6.22464 35 6.66667V18.3333H31.6667V8.33333H8.33333V13.3333L0 6.66667L8.33333 0V5ZM28.3333 31.6667H3.33333C2.89131 31.6667 2.46738 31.4911 2.15482 31.1785C1.84226 30.866 1.66667 30.442 1.66667 30V18.3333H5V28.3333H28.3333V23.3333L36.6667 30L28.3333 36.6667V31.6667Z"
      fill="#0F9129"
    />
  </Svg>
);

interface UnlinkedMyMoneyProps {
  onConnect: () => void;
}

const UnlinkedMyMoney: React.FC<UnlinkedMyMoneyProps> = ({ onConnect }) => {
  const { isDesktop } = useWindow();
  return (
    <View style={styles.container}>
      {/* Background Image */}
      <Image
        source={
          isDesktop
            ? Images.placeholderMyMoneyDesktop
            : Images.placeholderMyMoney
        }
        style={styles.backgroundImage}
        contentFit="cover"
      />
      <BlurView intensity={30} tint="light" style={styles.overlay} />

      {/* Overlay for opacity */}

      {/* Centered Popup */}
      <View style={styles.popupContainer}>
        <View style={styles.popup}>
          <View style={styles.iconContainer}>
            <RepeatIcon />
          </View>

          <Text style={styles.popupText}>
            Connect an account to get a real-time overview of your finances.
          </Text>

          <ActionButton
            title="Connect to continue"
            onPress={onConnect}
            style={styles.button}
          />
        </View>
      </View>
    </View>
  );
};

export default UnlinkedMyMoney;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  backgroundImage: {
    position: "absolute",
    width: "100%",
    height: "100%",
    resizeMode: "cover",
  },
  overlay: {
    position: "absolute",
    width: SCREEN_WIDTH,
    height: SCREEN_HEIGHT,
    backgroundColor: "rgba(255, 255, 255, 0.5)",
  },
  popupContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 20,
  },
  popup: {
    backgroundColor: "#E1EFE4",
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 24,
    width: "100%",
    maxWidth: 358,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 3,
  },
  iconContainer: {
    marginBottom: 12,
  },
  popupText: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 15,
    lineHeight: 25,
    letterSpacing: -0.15,
    color: "#161D14",
    textAlign: "center",
    marginBottom: 12,
  },
  button: {
    width: "100%",
    height: 56,
  },
});
